<template>
  <div class="container p-0" v-show="!hidden">
    <div class="input-group has-validation">
      <textarea :ref="'textarea_' + element.name" @input="elementChanged" @blur="elementChanged" :id="ids.input" :value="value"
        :name="element.name" :autocomplete="element.autocomplete || 'on'"
        class="form-control" :placeholder="getTextFor(element.placeholder, lang)" :required="element.required"
        :aria-describedby="describedBy" :aria-invalid="ariaInvalid" :disabled="hidden"></textarea>
    </div>
    <div class="invalid-feedback" :id="ids.error" :style="invalidStyle">{{ getTextFor(element.invalid, lang) }}</div>
    <div v-if="heeftUitleg" :id="ids.help" class="form-text">{{ getTextFor(element.explanation, lang) }}</div>
  </div>
</template>

<script>
import veldToegankelijkheid from '../../utils/veldToegankelijkheid'

export default {
  mixins: [veldToegankelijkheid],
  name: 'FormElementTextareaInput',
  props: ['element', 'lang', 'targetId', 'wasValidated', 'value', 'hidden'],
  emits: ['elementChanged'],
  methods: {
    elementChanged() {
      this.$emit('elementChanged', this.element.name, this.$refs['textarea_' + this.element.name].value)
    },
    checkFieldValidity(fieldRef) {
      const field = this.$refs[fieldRef];
      return field && field.checkValidity();
    },
    getTextFor(data, lang) {
      return data ? data[lang] : '';
    }
  },

}
</script>
